import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import FullPageLoader from "./FullPageLoader";

export default function AdminProtectedRoute({ children }) {
  const { user, token, loading } = useAuth();

  if (loading) {
    return <FullPageLoader show />;
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!user) {
    return <FullPageLoader show />;
  }

  if (user.role?.toLowerCase() !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
